// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__6QiUF","error":"Textarea_error__EY7Ha","readonly":"Textarea_readonly__3RLE4","disabled":"Textarea_disabled__1S7eN"};